import React, { useState, useContext, useEffect, useRef } from 'react';
import styles from './Skins.module.scss';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { IpContext, TokenContext, TYPES, ABIContext } from '../../components/Context';
import { Web3Context } from '../../web3/Web3Context';

import IconPolygonSmall from '../../assets/icons/icon-polygon.png';
import IconBinance from '../../assets/icons/BSC_network.png';
import IconBinanceWhite from '../../assets/icons/icon_binance_white.png';
import IconOpenSeaWhite from '../../assets/icons/icon_opensea_white.png';
import IconBridge from '../../assets/icons/icon_bridge.png';
import IconTransfer from '../../assets/icons/icon_transfer.png';
import IconMoreOptions from '../../assets/icons/icon-dots.png';

import SoulHarvester from '../../assets/imgs/skins/soul_harvester.png';
import PhantomQueen from '../../assets/imgs/skins/phantom_queen.png';
import MiraculousAngel from '../../assets/imgs/skins/miraculous_angel.png';
import DivineChampion from '../../assets/imgs/skins/divine_champion.png';
import SparklingFairy from '../../assets/imgs/skins/sparkling_fairy.png';
import ArchMage from '../../assets/imgs/skins/arch_mage.png';
import FantasyHealer from '../../assets/imgs/skins/fantasy_healer.png';
import MagicalWarrior from '../../assets/imgs/skins/magical_warrior.png';
import AssassinFemale from '../../assets/imgs/skins/assassin_female.png';
import AssassinMale from '../../assets/imgs/skins/assassin_male.png';
import CaptainFemale from '../../assets/imgs/skins/captain_female.png';
import CaptainMale from '../../assets/imgs/skins/captain_male.png';
import SoldierFemale from '../../assets/imgs/skins/soldier_female.png';
import SoldierMale from '../../assets/imgs/skins/soldier_male.png';
import RougeFemale from '../../assets/imgs/skins/rouge_female.png';
import RougeMale from '../../assets/imgs/skins/rouge_male.png';
import BardFemale from '../../assets/imgs/skins/bard_female.png';
import BardMale from '../../assets/imgs/skins/bard_male.png';

import { Button, Image, Overlay, Tooltip } from 'react-bootstrap';
import { returnRarityImage, skinMap } from './utils';
import axios from 'axios';
import { createContract } from '../../services/contractService';
import { allTokenTypes, toCamelCase } from './utils';
import { PolygonNetworkInfo, BinanceNetworkInfo } from '../../services/networkServices';
import { SkinAndTicketTransfer } from '../SkinAndTicketTransfer/SkinAndTicketTransfer';
import Loader from '../../assets/imgs/loader.gif';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import facebookIcon from '../../assets/icons/facebook1.png';
import telegramIcon from '../../assets/icons/telegramIcon.svg';
import twitterIcon from '../../assets/icons/twitterIcon.svg';
import sharelinkIcon from '../../assets/icons/sharelinkIcon.svg';
import { copyToClipboard } from '../../helpers';

const withdrawlURL = 'https://www.binance.com/en/support/faq/a2fb25696162460f9379c0ba43c5c622';
const binanceSkinsURL = 'https://www.binance.com/en/nft/mystery-box/collection/TOWER%20Mystery%20Box?orderBy=list_time&orderType=-1&isBack=1&id=151874104344294400&order=list_time%40-1';
const openseaURL = 'https://opensea.io/';
const OPENSEA_URL = process.env.REACT_APP_OPENSEA_URL;
const CDH_BACKEND_API = process.env.REACT_APP_BACKEND_API;

const Skins = (props) => {
    const { walletConnected } = props;
    const { selectedAccount, connect, networkId, web3, switchNetwork, provider } = useContext(Web3Context);
    const [state, dispatch] = useContext(TokenContext);
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [skinTypeForTransfer, setSkinTypeForTransfer] = useState('');
    const [skinImage, setSkinImage] = useState(BardFemale);
    const [maxTokenCount, setMaxTokenCount] = useState(0);
    const [abiConfig, abiDispatch] = useContext(ABIContext);
    const [binanceSkinsFetched, setBinanceSkinsFetched] = useState(false);
    const [binanceSpecialSkinsFetched, setBinanceSpecialSkinsFetched] = useState(false);
    const [switching, setSwitching] = useState(false);
    const [polygonSkinsFetched, setPolygonSkinsFetched] = useState(false);
    const [bridgingStatus, setBridgingStatus] = useState('');
    const WALLET_BRIDGING_STATUS_URL = `${process.env.REACT_APP_BACKEND_API}/bridging/${selectedAccount}`;
    const [t] = useTranslation();
    const history = useHistory();

    const [popOverMenu, setPopOverMenu] = useState(false);
    const [selectedSkin, setSelectedSkin] = useState('');
    const [socialShareLinks, setSocialShareLinks] = useState([]);
    const {isInChina} = useContext(IpContext);
    const tooltipTarget = useRef(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const getSocialLinks = (towerInventoryAddress='0x432de13822e0b891748b632cd94f85ba4cbbcdfa', tokenId='1') => {
        return [
          {
            icon: facebookIcon,
            name: 'Facebook',
            link: 'https://www.facebook.com/sharer/sharer.php?u=' +  OPENSEA_URL + towerInventoryAddress + "/" + tokenId,
            disabled: isInChina
          },
          {
            icon: telegramIcon,
            name: 'Telegram',
            link: 'https://telegram.me/share/url?url=' + OPENSEA_URL + towerInventoryAddress + "/" + tokenId,
            disabled: isInChina
          },
          {
            icon: twitterIcon,
            name: 'Twitter',
            link: 'https://twitter.com/intent/tweet?url=' + OPENSEA_URL + towerInventoryAddress + "/" + tokenId,
            disabled: isInChina
          },
          {
            icon: sharelinkIcon,
            name: 'Copy Link',
            copyLink: OPENSEA_URL + towerInventoryAddress + "/" + tokenId,
            disabled: isInChina
          },
        ];
    }

    const {
        skinAndTicket: { 
            skinContract,
            ticketContract,
            polygonTowerInventoryContract,
            nftReceiverContract,
        },
        polygonProvider,
        binanceProvider,
        binanceDeploymentContext,
        polygonDeploymentContext
    } = abiConfig;

    
    // Requires to initialize ticket contract because two skins are minted under Ticket Contract
    const initializeTicketContract = async () => {
        let contract;
        if(networkId === parseInt(process.env.REACT_APP_BINANCE_CHAIN_ID)) {
            contract = await createContract(binanceDeploymentContext, 'Ticket', provider);
        } else {
            contract = await createContract(binanceDeploymentContext, 'Ticket', binanceProvider.connection.url);
        }

        if(contract) {
            abiDispatch({
                type: TYPES.INIT_TICKET_CONTRACT,
                payload: {
                    ticketAddress: contract.options.address,
                    ticketContract: contract, 
                }
            });
        }
    }

    const initializeSkinContract = async () => {
        let contract;
        if(networkId === parseInt(process.env.REACT_APP_BINANCE_CHAIN_ID)) {
            contract = await createContract(binanceDeploymentContext, 'Skin', provider);
        } else {
            contract = await createContract(binanceDeploymentContext, 'Skin', binanceProvider.connection.url);
        }
        
        if(contract) {
            abiDispatch({
                type: TYPES.INIT_SKIN_CONTRACT,
                payload: {
                    skinAddress: contract.options.address,
                    skinContract: contract, 
                }
            });
        }
    }

    const initializePolygonSkinContract = async () => {
        let contract;
        if(networkId === parseInt(process.env.REACT_APP_POLYGON_CHAIN_ID)) {
            contract = await createContract(polygonDeploymentContext, 'TowerInventory', provider)
        } else {
            contract = await createContract(polygonDeploymentContext, 'TowerInventory', polygonProvider.connection.url);
        }

        if(contract) {
            abiDispatch({
                type: TYPES.INIT_POLYGON_TOWER_INVENTORY_CONTRACT,
                payload: {
                    polygonTowerInventoryAddress: contract.options.address,
                    polygonTowerInventoryContract: contract,
                }
            })
        }
    }

    const initializeNFTReceiverContract = async () => {
        let contract;
        if(networkId === parseInt(process.env.REACT_APP_BINANCE_CHAIN_ID)) {
            contract = await createContract(binanceDeploymentContext, 'NFTReceiver', provider);
        } else {
            contract = await createContract(binanceDeploymentContext, 'NFTReceiver', binanceProvider.connection.url);
        }
        
        if(contract) {
            abiDispatch({
                type: TYPES.INIT_NFT_RECEIVER_CONTRACT,
                payload: {
                    nftReceiverAddress: contract.options.address,
                    nftReceiverContract: contract,
                }
            })
        }
    }


    // Fetch regular skins on the Binance network (requires using skinContract)
    const fetchBinanceSkins = async () => {
        try {
            let skinBalance = {
                miraculousAngel: {
                    count: 0,
                    tokens: [],
                },
                divineChampion: {
                    count: 0,
                    tokens: [],
                },
                sparklingFairy: {
                    count: 0,
                    tokens: [],
                },
                archMage: {
                    count: 0,
                    tokens: [],
                },
                fantasyHealer: {
                    count: 0,
                    tokens: [],
                },
                magicalWarrior: {
                    count: 0,
                    tokens: [],
                },
                assassinFemale: {
                    count: 0,
                    tokens: [],
                },
                assassinMale: {
                    count: 0,
                    tokens: [],
                },
                captainFemale: {
                    count: 0,
                    tokens: [],
                },
                captainMale: {
                    count: 0,
                    tokens: [],
                },
                soldierFemale: {
                    count: 0,
                    tokens: [],
                },
                soldierMale: {
                    count: 0,
                    tokens: [],
                },
                rougeFemale: {
                    count: 0,
                    tokens: [],
                },
                rougeMale: {
                    count: 0,
                    tokens: [],
                },
                bardFemale: {
                    count: 0,
                    tokens: [],
                },
                bardMale: {
                    count: 0,
                    tokens: [],
                },
            }

            let skinIds = [];
            const totalSkinCount = await skinContract.methods.balanceOf(selectedAccount).call();
            if(totalSkinCount > 0) {
                for(let i = 0; i < totalSkinCount; i++) {
                    let skinTokenId = await skinContract.methods.tokenOfOwnerByIndex(selectedAccount, i).call();
                    skinIds.push(skinTokenId);
                }
            }
            
            let skinBackendAPI = CDH_BACKEND_API + "/skinmetadata";
            const data = {
                "tokenIds": skinIds
            }

            let rawTokenMetaData = await axios.post(skinBackendAPI, data).catch((err) => err.response);

            if(rawTokenMetaData && rawTokenMetaData?.status === 200) {
                skinBalance = rawTokenMetaData.data;
            }

            dispatch({
                type: TYPES.SET_SKIN_COUNT_BSC,
                payload: skinBalance,
            });

            setBinanceSkinsFetched(true);
        } catch(e) {
            console.log(`Error is ${e}`);
        }
    }

    // Fetch special edition skins on the Binance network (requires using ticketContract)
    const fetchBinanceSpecialSkins = async () => {
        try {
            let sesSkinBalance = {
                soulHarvester: {
                    count: 0,
                    tokens: [],
                },
                phantomQueen: {
                    count: 0,
                    tokens: [],
                },
            }

            let specialSkinIds = [];
            const totalSpecialSkinNFTCount = await ticketContract.methods.balanceOf(selectedAccount).call();
            if(totalSpecialSkinNFTCount > 0) {
                for(let i = 0; i < totalSpecialSkinNFTCount; i++) {
                    let specialSkinTokenId = await ticketContract.methods.tokenOfOwnerByIndex(selectedAccount, i).call();
                    specialSkinIds.push(specialSkinTokenId) 
                }
            }


            let sesBackendAPI = CDH_BACKEND_API + "/sesmetadata";
            const data = {
                "tokenIds": specialSkinIds
            }

            let rawTokenMetaData = await axios.post(sesBackendAPI, data).catch((err) => err.response);

            if(rawTokenMetaData && rawTokenMetaData?.status === 200) {
                sesSkinBalance = rawTokenMetaData.data;
            }

            dispatch({
                type: TYPES.SET_SPECIAL_SKIN_COUNT_BSC,
                payload: sesSkinBalance,
            });

            setBinanceSpecialSkinsFetched(true);
        } catch(e) {
            console.log(`Error is ${e}`);
        }
    }

    // Fetching all skins on the Polygon network (special and regular skins all minted under single contract)
    const fetchPolygonSkins = async () => {
        try {
            let polygonSkinBalance = {
                miraculousAngel: {
                    count: 0,
                },
                divineChampion: {
                    count: 0,
                },
                sparklingFairy: {
                    count: 0,
                },
                archMage: {
                    count: 0,
                },
                fantasyHealer: {
                    count: 0,
                },
                magicalWarrior: {
                    count: 0,
                },
                assassinMale: {
                    count: 0,
                },
                assassinFemale: {
                    count: 0,
                },
                captainFemale: {
                    count: 0,
                },
                captainMale: {
                    count: 0,
                },
                soldierFemale: {
                    count: 0,
                },
                soldierMale: {
                    count: 0,
                },
                rougeFemale: {
                    count: 0,
                },
                rougeMale: {
                    count: 0,
                },
                bardFemale: {
                    count: 0,
                },
                bardMale: {
                    count: 0,
                },
                soulHarvester: {
                    count: 0,
                },
                phantomQueen: {
                    count: 0,
                },
            }

            // we will explicitly fetch balance of skins using their id rather than using getAllTokens
            for(let i=4; i <= 21; i++) {
                const skinCode = i;
                const skinTokenType = allTokenTypes[skinCode].toString();
                const skinBalance = await polygonTowerInventoryContract.methods.balanceOf(selectedAccount, skinCode).call();
                polygonSkinBalance[skinTokenType]['count'] = skinBalance;
            }

            dispatch({
                type: TYPES.SET_SKIN_COUNT_MATIC,
                payload: polygonSkinBalance,
            });

            setPolygonSkinsFetched(true);
        } catch(e) {
            console.log(`Error is ${e}`);
        }
    }

    const returnTotalBSCSkinCount = () => {
        let totalBSCSkinCount = 0;
        Object.keys(state.skinBalance.bsc).forEach(keyName => {
            totalBSCSkinCount += state.skinBalance.bsc[keyName]['count'];
        })
        return totalBSCSkinCount;
    }

    const returnTotalPolygonSkinCount = () => {
        let totalPolygonSkinCount = 0;
        Object.keys(state.skinBalance.polygon).forEach(keyName => {
            totalPolygonSkinCount += parseInt(state.skinBalance.polygon[keyName]['count']);
        })
        return totalPolygonSkinCount;
    }

    const bscSkinData = {
        totalSkinCount: returnTotalBSCSkinCount(),
        soulHarvester: {
            img: SoulHarvester,
            name: 'Soul Harvester',
            rarity: 'SSR',
            quantity: state.skinBalance.bsc.soulHarvester.count,
        },

        phantomQueen: {
            img: PhantomQueen,
            name: 'Phantom Queen',
            rarity: 'SSR',
            quantity: state.skinBalance.bsc.phantomQueen.count,
        },

        miraculousAngel: {
            img: MiraculousAngel,
            name: 'Miraculous Angel',
            rarity: 'SSR',
            quantity: state.skinBalance.bsc.miraculousAngel.count,
        },

        divineChampion: {
            img: DivineChampion,
            name: 'Divine Champion',
            rarity: 'SSR',
            quantity: state.skinBalance.bsc.divineChampion.count,
        },

        sparklingFairy: {
            img: SparklingFairy,
            name: 'Sparkling Fairy',
            rarity: 'SR',
            quantity: state.skinBalance.bsc.sparklingFairy.count,
        },

        archMage: {
            img: ArchMage,
            name: 'Arch Mage',
            rarity: 'SR',
            quantity: state.skinBalance.bsc.archMage.count,
        },

        fantasyHealer: {
            img: FantasyHealer,
            name: 'Fantasy Healer',
            rarity: 'SR',
            quantity: state.skinBalance.bsc.fantasyHealer.count,
        },

        magicalWarrior: {
            img: MagicalWarrior,
            name: 'Magical Warrior',
            rarity: 'SR',
            quantity: state.skinBalance.bsc.magicalWarrior.count,
        },

        assassinFemale: {
            img: AssassinFemale,
            name: 'Assassin Female',
            rarity: 'R',
            quantity: state.skinBalance.bsc.assassinFemale.count,
        },

        assassinMale: {
            img: AssassinMale,
            name: 'Assassin Male',
            rarity: 'R',
            quantity: state.skinBalance.bsc.assassinMale.count,
        },

        captainFemale: {
            img: CaptainFemale,
            name: 'Captain Female',
            rarity: 'R',
            quantity: state.skinBalance.bsc.captainFemale.count,
        },

        captainMale: {
            img: CaptainMale,
            name: 'Captain Male',
            rarity: 'R',
            quantity: state.skinBalance.bsc.captainMale.count,
        },

        soldierFemale: {
            img: SoldierFemale,
            name: 'Soldier Female',
            rarity: 'N',
            quantity: state.skinBalance.bsc.soldierFemale.count,
        },

        soldierMale: {
            img: SoldierMale,
            name: 'Soldier Male',
            rarity: 'N',
            quantity: state.skinBalance.bsc.soldierMale.count,
        },

        rougeFemale: {
            img: RougeFemale,
            name: 'Rouge Female',
            rarity: 'N',
            quantity: state.skinBalance.bsc.rougeFemale.count,
        },

        rougeMale: {
            img: RougeMale,
            name: 'Rouge Male',
            rarity: 'N',
            quantity: state.skinBalance.bsc.rougeMale.count,
        },

        bardFemale: {
            img: BardFemale,
            name: 'Bard Female',
            rarity: 'N',
            quantity: state.skinBalance.bsc.bardFemale.count,
        },

        bardMale: {
            img: BardMale,
            name: 'Bard Male',
            rarity: 'N',
            quantity: state.skinBalance.bsc.bardMale.count,
        }
    }

    const polygonSkinData = {
        totalSkinCount: returnTotalPolygonSkinCount(),
        soulHarvester: {
            img: SoulHarvester,
            name: 'Soul Harvester',
            rarity: 'SSR',
            quantity: state.skinBalance.polygon.soulHarvester.count,
        },

        phantomQueen: {
            img: PhantomQueen,
            name: 'Phantom Queen',
            rarity: 'SSR',
            quantity: state.skinBalance.polygon.phantomQueen.count,
        },

        miraculousAngel: {
            img: MiraculousAngel,
            name: 'Miraculous Angel',
            rarity: 'SSR',
            quantity: state.skinBalance.polygon.miraculousAngel.count,
        },

        divineChampion: {
            img: DivineChampion,
            name: 'Divine Champion',
            rarity: 'SSR',
            quantity: state.skinBalance.polygon.divineChampion.count,
        },

        sparklingFairy: {
            img: SparklingFairy,
            name: 'Sparkling Fairy',
            rarity: 'SR',
            quantity: state.skinBalance.polygon.sparklingFairy.count,
        },

        archMage: {
            img: ArchMage,
            name: 'Arch Mage',
            rarity: 'SR',
            quantity: state.skinBalance.polygon.archMage.count,
        },

        fantasyHealer: {
            img: FantasyHealer,
            name: 'Fantasy Healer',
            rarity: 'SR',
            quantity: state.skinBalance.polygon.fantasyHealer.count,
        },

        magicalWarrior: {
            img: MagicalWarrior,
            name: 'Magical Warrior',
            rarity: 'SR',
            quantity: state.skinBalance.polygon.magicalWarrior.count,
        },

        assassinFemale: {
            img: AssassinFemale,
            name: 'Assassin Female',
            rarity: 'R',
            quantity: state.skinBalance.polygon.assassinFemale.count,
        },

        assassinMale: {
            img: AssassinMale,
            name: 'Assassin Male',
            rarity: 'R',
            quantity: state.skinBalance.polygon.assassinMale.count,
        },

        captainFemale: {
            img: CaptainFemale,
            name: 'Captain Female',
            rarity: 'R',
            quantity: state.skinBalance.polygon.captainFemale.count,
        },

        captainMale: {
            img: CaptainMale,
            name: 'Captain Male',
            rarity: 'R',
            quantity: state.skinBalance.polygon.captainMale.count,
        },

        soldierFemale: {
            img: SoldierFemale,
            name: 'Soldier Female',
            rarity: 'N',
            quantity: state.skinBalance.polygon.soldierFemale.count,
        },

        soldierMale: {
            img: SoldierMale,
            name: 'Soldier Male',
            rarity: 'N',
            quantity: state.skinBalance.polygon.soldierMale.count,
        },

        rougeFemale: {
            img: RougeFemale,
            name: 'Rouge Female',
            rarity: 'N',
            quantity: state.skinBalance.polygon.rougeFemale.count,
        },

        rougeMale: {
            img: RougeMale,
            name: 'Rouge Male',
            rarity: 'N',
            quantity: state.skinBalance.polygon.rougeMale.count,
        },

        bardFemale: {
            img: BardFemale,
            name: 'Bard Female',
            rarity: 'N',
            quantity: state.skinBalance.polygon.bardFemale.count,
        },

        bardMale: {
            img: BardMale,
            name: 'Bard Male',
            rarity: 'N',
            quantity: state.skinBalance.polygon.bardMale.count,
        }
    }

    const renderSkinsLoading = (
        <div className={styles.skins_loading}>
            <div>
                <img className={styles.skins_loading_icon} src={Loader} alt="loading" />
            </div>
            <div className={styles.skins_loading_text}>
                {`We're loading your inventory...`}
            </div>
        </div>
    );

    const renderBSCSkins = (bscSkinData) => {
        // const allSkinCounts = bscSkinData['totalSkinCount']
        const allSkinsName = Object.keys(bscSkinData).filter((keyName) => keyName !== 'totalSkinCount');
        const allSkins = allSkinsName.map((skinName) => {
            return bscSkinData[skinName]
        });

        // filter out skins data if there are zero units of skins held
        const allSkinFiltered = allSkins.filter(skin => skin['quantity'] > 0);

        return (
            <>
                {/* <div className={styles.bsc_skins_count}>
                    {`Total: ${allSkinCounts}`}
                </div> */}
                {allSkinFiltered.map(skin => {
                    return (
                        <div key={skin['name']} className={styles.bsc_skins}>
                            { renderSingleBSCSkin(skin['img'], skin['name'], skin['rarity'], skin['quantity'])}
                        </div>
                    )
                })}
            </>
            
        );
    }

    const renderPolygonSkins = (polygonSkinData) => {
        const allSkinsName = Object.keys(polygonSkinData).filter((keyName) => keyName !== 'totalSkinCount');
        const allSkins = allSkinsName.map((skinName) => {
            return polygonSkinData[skinName]
        });

        // filter out skins data if there are zero units of skins held
        const allSkinFiltered = allSkins.filter(skin => skin['quantity'] > 0);

        return (
            allSkinFiltered.map(skin => {
                return (
                    <div key={skin['name']} className={styles.polygon_skins}>
                        { renderSinglePolygonSkin(skin['img'], skin['name'], skin['rarity'], skin['quantity'])}
                    </div>
                )
            })
        );
    }

    const bridgeWrapper = (skinName) => {
        if(networkId != parseInt(process.env.REACT_APP_BINANCE_CHAIN_ID)) {
            switchNetwork(BinanceNetworkInfo)
            setSwitching(true);
        } else {
            initiateSkinBridging(skinName);
        }
    }

    const initiateSkinBridging = (skinName) => {
        const bridgingSkinType = skinName.split(' ')[0].toLowerCase().concat(skinName.split(' ')[1]);

        dispatch({
            type: TYPES.SET_BRIDGING_SKIN_TYPE_BSC,
            payload: bridgingSkinType,
        })

        history.push('/bridge/skins');
    }

    const renderSingleBSCSkin = (skinImg, name, rarity, qty) => {
        const rarityImage = returnRarityImage(rarity);
        return (
            <div className={styles.bsc_singleskin_skins}>
                <div className={styles.bsc_singleskin_header}>
                    <div className={styles.bsc_singleskin_bsc_logo}>
                        <Image src={IconBinance} alt="binance" />
                    </div>
                    
                </div>
                <div className={styles.bsc_singleskin_image_count_rarity}>
                    <div className={styles.bsc_singleskin_image}>
                        <Image width="125" height="125" src={skinImg} />
                    </div>
                    <div className={styles.bsc_singleskin_qty}>
                        {`x${qty}`}
                    </div>
                    <div className={styles.bsc_singleskin_rarity}>
                        <Image height="13" src={rarityImage} />
                    </div>
                </div>
                <div className={styles.bsc_singleskin_name}>
                    {name}
                </div>
                
                {/* Commented out the section for divider and bridge button */}
                <div className={styles.singleskin_divider}></div>
                <div>
                    <Button disabled= {qty < 1 || bridgingStatus === 'minting' || switching} className={`${styles.bsc_singleskin_bridge_btn} ${switching ? styles.bsc_singleskin_bridge_btn_disabled : ''}`} onClick={() => bridgeWrapper(name)}>
                        <div className={styles.bsc_singleskin_bridge_icon}>
                            <Image src={IconBridge} />
                        </div>
                        <div className={styles.bsc_singleskin_bridge_text}>
                            {`${(networkId != parseInt(process.env.REACT_APP_BINANCE_CHAIN_ID)) ? 'Switch' : t('BRIDGE_POLYGON_BTN')}`}
                        </div>
                    </Button>
                </div>
            </div>
        );
    }

    const renderAdditionalPopUp = (skinImageText) => {
        console.log("SkinImageText is: ", skinImageText);
        setPopOverMenu(true);
        setSelectedSkin(skinImageText);
    }

    const renderSinglePolygonSkin = (skinImg, name, rarity, qty) => {
        const rarityImage = returnRarityImage(rarity);
        return (
            <div className={styles.polygon_singleskin_skins}>
                <div className={styles.polygon_singleskin_header}>
                    <div className={styles.polygon_singleskin_polygon_logo}>
                        <Image src={IconPolygonSmall} alt="polygon" />
                    </div>

                    <div className={styles.polygon_singleskin_more_options} onClick={() => renderAdditionalPopUp(name)}>
                        <Image src={IconMoreOptions} alt="more-options" />
                    </div>

                    {/* Rendering of overlay */}
                    {(selectedSkin === name) && 
                    <div className={`${styles.polygon_singleskin_options_popup} ${popOverMenu && styles.displayBlock}`}>
                        <span className={styles.closeBtn} onClick={() => setPopOverMenu(false)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </span>
                        <h3 className={styles.title}>{name}</h3>
                        <ul className={styles.shareLinks}>
                            {socialShareLinks.map((item, idx) => {
                                if (!item.disabled && !item.copyLink) {
                                return (
                                    <li key={idx}>
                                    <a href={item.link?.toLowerCase()} target="_blank" rel="noreferrer noopener"><img src={item.icon} alt='' />{item.name}</a>
                                    </li>
                                );
                                } else if (!item.disabled) {
                                return (
                                    <li key={idx}>
                                    <span className={styles.copyToClipboard} onClick={() => copyToClipboard(item.copyLink)}><img src={item.icon} alt='' />{item.name}</span>
                                        <Overlay target={tooltipTarget.current} ref={tooltipTarget} show={showTooltip} placement="top">
                                        {(props) => (
                                            <Tooltip id="overlay-example" {...props}>
                                                {'Copied'}
                                            </Tooltip>
                                        )}
                                        </Overlay>
                                    </li>
                                );
                                }
                            })}
                        </ul>

                        <button className={`${styles.transferBtn} ${(qty == 0) ? styles.transferBtnDisabled : ''}`} onClick={() => initiateTransfer(selectedSkin)}>
                            <img src={IconTransfer} alt="transfer" />
                            {'Transfer'}
                        </button>
                    </div>}
                </div>
                <div className={styles.polygon_singleskin_image_count_rarity}>
                    <div className={styles.polygon_singleskin_image}>
                        <Image width="125" height="125" src={skinImg} />
                    </div>
                    <div className={styles.polygon_singleskin_qty}>
                        {`x${qty}`}
                    </div>
                    <div className={styles.polygon_singleskin_rarity}>
                        <Image height="13" src={rarityImage} />
                    </div>
                </div>
                <div className={styles.polygon_singleskin_name}>
                    {name}
                </div>
                
                <div className={styles.singleskin_divider}></div>
                <div>
                    <Button disabled className={styles.polygon_singleskin_transfer_btn} onClick={() => initiateRedemption(name)}>
                        <div className={styles.polygon_singleskin_transfer_icon}>
                            <Image src={IconTransfer} />
                        </div>
                        <div className={styles.polygon_singleskin_transfer_text}>
                            {t('REDEEM')}
                        </div>
                    </Button>
                </div>
            </div>
        );
    }

    const renderBridgingInProgress = (
        <div className={styles.bridging_in_progress}>
            <span>{'Bridging is currently in progress. You cannot bridge other tokens while bridging is in progress'}</span>
        </div>
    );

    const renderBridgingFailed = (
        <div className={styles.bridging_failed}>
            <span>{'Mint transaction failed. Our system will re-attempt to mint corresponding token to your wallet address. Please check again later!'}</span>
        </div>
    );

    const renderBSCNoSkins = (
        <div className={styles.bsc_no_skins}>
            <div className={styles.bsc_no_skins_text}>
                {t('SKINS_EMPTY_TITLE')}
            </div>
            <div className={styles.bsc_no_skins_description}>
                {t('BUY_FROM_BINANCE')}
            </div>
            <div>
                <Button className={styles.bsc_binance_btn}>
                    <div className={styles.bsc_btn_icon}>
                        <Image width="16" src={IconBinanceWhite} />
                    </div>
                    <a href={binanceSkinsURL} target="_blank" rel="noopener noreferrer">
                        <div className={styles.bsc_btn_text}>
                            {'Go To Binance'}
                        </div>
                    </a>
                </Button>
            </div>
            <div className={styles.withdrawl_description}>
                {t('SKIN_WITHDRAWL_DESCRIPTION')}
            </div>
            <a href={withdrawlURL} target="_blank" rel="noopener noreferrer">
                <div className={styles.bsc_how_to_link}>
                    {t('HOW_TO_WITHDRAW')}
                </div>
            </a>
        </div>
    );

    const renderPolygonNoSkins = (
        <div className={styles.polygon_no_skins}>
            <div className={styles.polygon_no_skins_text}>
                {t('SKINS_EMPTY_TITLE')}
            </div>
            <div className={styles.polygon_no_skins_description}>
                {'You are able to purchase in OpenSea.'}
            </div>
            <div>
                <Button className={styles.polygon_opensea_btn}>
                    <div className={styles.polygon_btn_icon}>
                        <Image width="16" src={IconOpenSeaWhite} />
                    </div>
                    <a href={openseaURL} target="_blank" rel="noopener noreferrer">
                        <div className={styles.polygon_btn_text}>
                            {t('GO_OPENSEA_BTN')}
                        </div>
                    </a>
                </Button>
            </div>
        </div>
    );

    const initiateTransfer = async (skinName) => {
        let switchNetworkResponse = await switchNetwork(PolygonNetworkInfo);
        if (!switchNetworkResponse) {
            return;
        }
        
        let selectedSkin;
        Object.keys(skinMap).forEach(keyName => {
            if(skinMap[keyName]['name'] == skinName) {
                selectedSkin = keyName;
            }
        });
        const maxCount = polygonSkinData[selectedSkin]['quantity']
        setShowTransferModal(true);
        setSkinTypeForTransfer(skinName);
        setMaxTokenCount(maxCount);
        setSkinImage(polygonSkinData[selectedSkin]['img'])
    }

    const initiateRedemption = (skinName) => {
        console.log("Initiate skin redemption here!", {skinName})
    }

    // Commenting out the code block for fetching briding status
    // useEffect(() => {
    //     if(selectedAccount) {
    //         const fetchWalletBridgingStatus = setInterval(async () => {
    //             try {
    //                 const rawResult = await axios.get(WALLET_BRIDGING_STATUS_URL);
    //                 if(rawResult.status === 200) {
    //                     const res = rawResult.data;
    //                     setBridgingStatus(res.status)
    //                 }
    //             } catch(e) {
    //                 console.log(`Error: ${e}`);
    //             }
    //         }, 60000);
    //     }
    // }, [selectedAccount])

    useEffect(() => {
        const contractInitializer = async () => {
            await initializeSkinContract()
            await initializeTicketContract()
            await initializePolygonSkinContract()
            await initializeNFTReceiverContract()
            setSwitching(false);
        }

        if(provider && binanceDeploymentContext && binanceProvider && polygonProvider && polygonDeploymentContext) {
            contractInitializer()
        }
    }, [provider, networkId, binanceDeploymentContext, binanceProvider, polygonDeploymentContext, polygonProvider]);

    // Segregated calls to fetching skins from different contracts - to avoid multiple calls when other contracts are initialized
    useEffect(() => {
        if(selectedAccount && skinContract) {
            fetchBinanceSkins();
        }
    }, [skinContract, selectedAccount]);

    useEffect(() => {
        if(selectedAccount && ticketContract) {
            fetchBinanceSpecialSkins();
        }
    }, [ticketContract, selectedAccount]);

    useEffect(() => {
        if(selectedAccount && polygonTowerInventoryContract) {
            fetchPolygonSkins();
        }
    }, [polygonTowerInventoryContract, selectedAccount]);

    useEffect(() => {
        if(polygonDeploymentContext && selectedSkin && polygonSkinsFetched) {
            const polygonTowerContractAddr = polygonDeploymentContext.contracts.TowerInventory.address;
            const selectedSkinArr = selectedSkin.split(" ");
            const selectedSkinCamelCase = toCamelCase(selectedSkinArr);

            let skinIdForTransfer;
            Object.keys(allTokenTypes).forEach(key => {
                if(allTokenTypes[key] === selectedSkinCamelCase) {
                    skinIdForTransfer = key;
                }
            });
            
            let socialLinksResult = getSocialLinks(polygonTowerContractAddr, skinIdForTransfer);
            setSocialShareLinks([...socialLinksResult]);
        }
        
    }, [polygonSkinsFetched, selectedSkin])

    return (
        <>
        {walletConnected ?
            <div className={styles.skins_items_section}>
                <div className={styles.skin_main_text}>
                    <div className={styles.skin_bridging_text}>{t('SKINS_MAIN_TITLE')}</div>
                    <div className={styles.total_skins}>{`Total: ${bscSkinData.totalSkinCount + polygonSkinData.totalSkinCount}`}</div>
                </div>
                <div className={styles.skin_network_groups}>
                    <div className={`${styles.bsc_network_group} ${styles.bsc_network_background}`}>
                        
                        {/* Commenting out the code block for BSC network title and horizontal line */}
                        <div className={styles.bsc_network_title}>
                            <div className={styles.bsc_network_icon}>
                                <Image src={IconBinance} />
                            </div>
                            <div className={styles.bsc_network_description}>
                                <div className={styles.bsc_network_text}>
                                    {'Network'}
                                </div>
                                <div className={styles.bsc_network_name}>
                                    {'BNB'}
                                </div>
                            </div>
                        </div>
                        <div className={styles.bsc_network_hr_line}></div>
                        
                        {/* Hiding the banner that says bridging in progress or failed */}
                        {/* <div>
                            {bridgingStatus === 'minting' ?
                                renderBridgingInProgress :
                                bridgingStatus === 'failed' ?
                                    renderBridgingFailed : ''
                            }
                        </div> */}
                        <div className={styles.bsc_network_content}>
                            {!binanceSkinsFetched || !binanceSpecialSkinsFetched ?
                                renderSkinsLoading : (
                                    (binanceSkinsFetched && binanceSpecialSkinsFetched) && (bscSkinData.totalSkinCount > 0) ?
                                    renderBSCSkins(bscSkinData) :
                                    renderBSCNoSkins
                                )
                            }    
                        </div>
                    </div>

                    {/* Commenting out the code blocks for Skins in polygon network section */}
                    <div className={`${styles.polygon_network_group} ${styles.polygon_network_background}`}>
                        <div className={styles.polygon_network_title}>
                            <div className={`${styles.polygon_network_icon} ${styles.polygon_network_icon_background}`}>
                                <Image width="34" height="34" src={IconPolygonSmall} />
                            </div>
                            <div className={styles.polygon_network_description}>
                                <div className={styles.polygon_network_text}>
                                    {'Network'}
                                </div>
                                <div className={styles.polygon_network_name}>
                                    {'Polygon'}
                                </div>
                            </div>
                        </div>
                        <div className={styles.polygon_network_hr_line}></div>
                        <div className={styles.polygon_network_content}>
                            {!polygonSkinsFetched ?
                                renderSkinsLoading : (
                                    polygonSkinsFetched && ((polygonSkinData.totalSkinCount > 0) ?
                                        renderPolygonSkins(polygonSkinData) :
                                        renderPolygonNoSkins
                                    )
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
            :
            <div className={styles.no_items_section}>
                <div className={styles.main_text}>{t('CONNECT_WALLET_ACCESS_INVENTORY')}</div>
                <div className={styles.secondary_text}>{t('NO_ITEMS_WITHOUT_CONNECT')}</div>
                <Button variant="cdh-general-blue-dbrown" className={styles.primary_btn} onClick={connect}>{t('CONNECT')}</Button>
            </div>}

            { 
                showTransferModal === true 
                    ? <SkinAndTicketTransfer
                        web3={web3}
                        showTransferModal={showTransferModal}
                        setShowTransferModal={setShowTransferModal}
                        switchNetwork={switchNetwork}
                        PolygonNetworkInfo= {PolygonNetworkInfo}
                        maxTokenCount={maxTokenCount}
                        skinTypeForTransfer={skinTypeForTransfer} 
                        skinImage={skinImage} />
                    : <></>
            }
        </>
    )
}

export { Skins }
